import React from "react";
import SelectInput from "../select-input";
import { DefaultPayment } from "./credit-card-fields-components/default-payment";
import { PaymentGroupTypes } from "./types/payment-groups.types";

export const PaymentGroup = ({
  paymentTypes,
  children,
  defaultCheckBoxProps,
}: PaymentGroupTypes): React.ReactElement => {
  return (
    <>
      <SelectInput {...paymentTypes} />
      {children}
      <DefaultPayment {...defaultCheckBoxProps} />
    </>
  );
};
